'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var afterRender = function afterRender(_ref) {
	var props = _ref.props;
	var script = props.script,
	    id = props.id;

	var elId = 'CMS-Component-Script-' + id;
	var elem = document.getElementById(elId);

	if (elem) {
		elem.remove();
	}

	var el = document.createElement('script');

	el.innerHTML = script;
	el.id = elId;

	document.body.appendChild(el);
};

var render = function render(_ref2) {
	var props = _ref2.props;
	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)('div', { 'class': 'CMS-Component-Script' }), props);
};

exports.default = { render: render, afterRender: afterRender };